import {Component, Input, OnInit} from '@angular/core';
import {InstallationQuote} from '../../../../../../../../../../quotes/src/app/data/Installation-quote';
import {QuotesService} from '../../../../../../../../../../quotes/src/app/data/quotes.service';
import {MiscSnackBarService} from '../../../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';

@Component({
  selector: 'app-installer-quote',
  templateUrl: './installer-quote.component.html',
  styleUrls: ['./installer-quote.component.scss']
})
export class InstallerQuoteComponent implements OnInit {

  @Input()
  quote: InstallationQuote;

  constructor(
    protected quotesService: QuotesService,
    protected miscSnackBarService: MiscSnackBarService
  ) {
  }

  ngOnInit(): void {

  }
}
